import { CheckCircleIcon } from "@phosphor-icons/react";

import { clsx } from "@alpacahq/ui/old";

import { Spinner } from "./Spinner";

interface BuySellButtonsProps {
  onBuyClicked: () => void;
  onSellClicked: () => void;
  isDisabled: boolean;
  isLoading: boolean;
  isSubmitted: boolean;
  buyLabel?: string;
  sellLabel?: string;
}

export const BuySellButtons = ({
  onBuyClicked,
  onSellClicked,
  isDisabled,
  isLoading,
  isSubmitted,
  buyLabel = "Buy",
  sellLabel = "Sell",
}: BuySellButtonsProps) => {
  const showStatus = isLoading || isSubmitted;

  return (
    <div className="relative h-9">
      <div
        className={clsx(
          "absolute inset-0 flex h-9 items-center justify-center rounded bg-[rgba(215,215,215,0.24)] p-2",
          "transition-all duration-200 ease-out",
          showStatus
            ? "scale-100 opacity-100"
            : "pointer-events-none scale-95 opacity-0",
          isLoading && "cursor-wait",
          isSubmitted && "cursor-default",
        )}
      >
        {isSubmitted ? (
          <div className="flex items-center gap-2">
            <CheckCircleIcon size={20} className="text-emerald-600" />
            <p className="m-0 p-0 font-medium text-emerald-600 text-sm">
              Order Submitted
            </p>
          </div>
        ) : (
          <Spinner />
        )}
      </div>

      <div
        className={clsx(
          "flex h-full items-center gap-2",
          "transition-all duration-200 ease-out",
          showStatus
            ? "pointer-events-none scale-95 opacity-0"
            : "scale-100 opacity-100",
        )}
      >
        <button
          onClick={onBuyClicked}
          disabled={isDisabled}
          className={clsx(
            "flex h-9 w-full items-center justify-center p-2 font-medium text-sm",
            "rounded border border-emerald-600 bg-[rgba(167,243,208,0.24)] text-emerald-600 transition-colors",
            "hover:border-emerald-500 hover:text-emerald-500",
            "active:border-emerald-400 active:text-emerald-400",
            "disabled:border-gray-300 disabled:bg-[rgba(215,215,215,0.24)] disabled:text-gray-300",
          )}
          type="button"
        >
          {buyLabel}
        </button>
        <button
          onClick={onSellClicked}
          disabled={isDisabled}
          className={clsx(
            "flex h-9 w-full items-center justify-center p-2 font-medium text-sm",
            "rounded border border-red-600 bg-[rgba(254,202,202,0.24)] text-red-600 transition-colors",
            "hover:border-red-500 hover:text-red-500",
            "active:border-red-400 active:text-red-400",
            "disabled:border-gray-300 disabled:bg-[rgba(215,215,215,0.24)] disabled:text-gray-300",
          )}
          type="button"
        >
          {sellLabel}
        </button>
      </div>
    </div>
  );
};
